const story1 = {
    videoUrl: 'https://hbrbapp.hubeidaily.net/h5/%E6%95%85%E4%BA%8B1.mp4',
    videoPostUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/%E5%8E%8B%E7%BC%A9%E5%B0%81%E9%9D%A21.jpg',
    photoImageUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedphoto1-new.jpg',
    backgroundImageUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedpicture1-new-3.jpg',
    photoHeight: 79,
    photoPosition: {
        x: 70,
        y: 484
    },
    photoTop: 481,
    postToTop: 6,
    photoMaskPosition: '70% 15%',
    areaInfo: {
        // width: 90,
        height: 93,
        top: 235,
        // left: 5
    },
    firstPathList: [{
        x: 42,
        y: 247
    }, {
        x: 5,
        y: 310
    }, {
        x: 4,
        y: 410
    }],
    secondPathList: [{
        x: 76,
        y: 630
    }, {
        x: 80,
        y: 680
    }, {
        x: 12,
        y: 808
    }, {
        x: 94,
        y: 940
    }, {
        x: 80,
        y: 1050
    },  {
        x: 15,
        y: 1158
    }, {
        x: 90,
        y: 1256
    }, {
        x: 90,
        y: 1350
    }, {
        x: 90,
        y: 1440
    }, {
        x: 14,
        y: 1538
    }, {
        x: 50,
        y: 1666
    }]
}
const story2 = {
    videoUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/%E6%95%85%E4%BA%8B2.mp4',
    videoPostUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/%E5%8E%8B%E7%BC%A9%E5%B0%81%E9%9D%A22.jpg',
    photoImageUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedphoto2-new.jpg',
    backgroundImageUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedpicture2-new4.jpg',
    photoHeight: 79,
    photoPosition: {
        x: 15,
        y: 1794
    },
    photoTop: 87,
    postToTop: 7,
    photoMaskPosition: '15% 15%',
    areaInfo: {
        height: 66,
        top: -73,
    },
    firstPathList: [{
        x: 50,
        y: 1666
    }],
    secondPathList: [{
        x: 15,
        y: 1954
    }, {
        x: 15,
        y: 2034
    }, {
        x: 91,
        y: 2154
    }, {
        x: 10,
        y: 2258
    }, {
        x: 83,
        y: 2369
    }, {
        x: 10,
        y: 2514
    }, {
        x: 88,
        y: 2625
    }, {
        x: 11,
        y: 2721
    }, {
        x: 50,
        y: 2910
    }]
}
const story3 = {
    videoUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/%E6%95%85%E4%BA%8B3.mp4',
    videoPostUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/%E5%8E%8B%E7%BC%A9%E5%B0%81%E9%9D%A23.jpg',
    photoImageUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedphoto3-new.jpg',
    backgroundImageUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedphoto3-new-1.jpg',
    photoHeight: 79,
    photoPosition: {
        x: 8,
        y: 3052
    },
    photoTop: 87,
    postToTop: 11,
    photoMaskPosition: '5% 5%',
    areaInfo: {
        height: 66,
        top: -73,
    },
    firstPathList: [ {
        x: 50,
        y: 2910
    }],
    secondPathList: [{
        x: 13,
        y: 3190
    }, {
        x: 8,
        y: 3340
    }, {
        x: 90,
        y: 3465
    }, {
        x: 7,
        y: 3595
    }, {
        x: 88,
        y: 3764
    }, {
        x: 8,
        y: 3876
    }, {
        x: 50,
        y: 4050
    }]
}
const story4 = {
    videoUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/%E6%95%85%E4%BA%8B4.mp4',
    videoPostUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedpost4.jpg',
    photoImageUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedphoto4-new.jpg',
    backgroundImageUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedpicture4-new.jpg',
    photoHeight: 79,
    photoPosition: {
        x: 88,
        y: 4186
    },
    photoTop: 87,
    postToTop: 9.8,
    photoMaskPosition: '85% 10%',
    areaInfo: {
        height: 66,
        top: -73,
    },
    firstPathList: [{
        x: 50,
        y: 4050
    }],
    secondPathList: [{
        x: 88,
        y: 4315
    },  {
        x: 49,
        y: 4429
    }, {
        x: 6,
        y: 4530
    }, {
        x: 87,
        y: 4658
    },  {
        x: 5,
        y: 4782
    }, {
        x: 92,
        y: 4899
    }, {
        x: 11,
        y: 5000
    }, {
        x: 90,
        y: 5130
    }, {
        x: 9,
        y: 5215
    }, {
        x: 50,
        y: 5362
    }]
}
const story5 = {
    videoUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/%E6%95%85%E4%BA%8B5.mp4',
    videoPostUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedpost5.jpg',
    photoImageUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedphoto5-new.jpg',
    backgroundImageUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedpicture5.jpg',
    photoHeight: 62,
    photoPosition:{
        x: 5,
        y: 5498
    },
    photoTop: 87,
    postToTop: 11,
    photoMaskPosition: '5% 5%',
    areaInfo: {
        height: 66,
        top: -73,
    },
    firstPathList: [{
        x: 50,
        y: 5362
    }],
    secondPathList: [{
        x: 11,
        y: 5671
    }, {
        x: 90,
        y: 5789
    }, {
        x: 2,
        y: 5877
    }, {
        x: 90,
        y: 6029
    }, {
        x: 20,
        y: 6178
    }, {
        x: 9,
        y: 6320
    },  {
        x: 50,
        y: 6490
    }]
}
// 1118
const story6 = {
    videoUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/%E6%95%85%E4%BA%8B6.mp4',
    videoPostUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedpost7.jpg',
    photoImageUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedphoto6-new.jpg',
    backgroundImageUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedpicture6-new1.jpg',
    photoHeight: 72,
    photoPosition: {
        x: 5,
        y: 6625
    },
    photoTop: 87,
    postToTop: 6.4,
    photoMaskPosition: '5% 5%',
    areaInfo: {
        height: 66,
        top: -73,
    },
    firstPathList: [{
        x: 50,
        y: 6490
    }],
    secondPathList: [
        // {"x":5,"y":6},
        {"x":5,"y":6732},
        {"x":85,"y":6822},
        {"x":90,"y":6873},
        {"x":3,"y":6977},
        {"x":90,"y":7073},
        // {"x":3,"y":7118},
        {"x":93,"y":7189},
        {"x":5,"y":7318},
        {"x":92,"y":7382},
        {"x":7,"y":7446},
        {"x":90,"y":7542},
        // {"x":91,"y":7600},
        {"x":9,"y":7678},
        {"x":50,"y":7800}
    ]
}
const story7 = {
    videoUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/%E6%95%85%E4%BA%8B7.mp4',
    videoPostUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedpost6.jpg',
    photoImageUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedphoto7-new.jpg',
    backgroundImageUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedpicture7-new.jpg',
    photoHeight: 72,
    photoPosition: {
        x: 8,
        y: 7930
    },
    photoTop: 87,
    postToTop: 7,
    photoMaskPosition: '5% 5%',
    areaInfo: {
        height: 66,
        top: -73,
    },
    firstPathList: [{
        x: 50,
        y: 7800
    }],
    secondPathList: [
        {"x":8,"y":8104},
        {"x":75,"y":8245},
        {"x":13,"y":8374},
        {"x":90,"y":8510},
        {"x":72,"y":8688},
        {"x":12,"y":8840},
        {"x":50,"y":8980}
    ]
}
const story8 = {
    videoUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/%E6%95%85%E4%BA%8B8.mp4',
    videoPostUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedpost8.jpg',
    photoImageUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedphoto8-new.jpg',
    backgroundImageUrl: 'https://hbrbapp.hubeidaily.net/h5/family-photo/Compressedpicture8-new.jpg',
    photoHeight: 72,
    photoPosition: {
        x: 58,
        y: 9112
    },
    photoTop: 87,
    postToTop: 264,
    photoMaskPosition: '57% 5%',
    areaInfo: {
        height: 66,
        top: -73,
    },
    firstPathList: [{
        x: 50,
        y: 8980
    }],
    secondPathList: [
        {"x":58,"y":9288},
        {"x":70,"y":9413},
        {"x":20,"y":9510},
        {"x":11,"y":9607},
        {"x":16,"y":9776},
        {"x":92,"y":9961},
        {"x":50,"y":10083}
    ]
}

const data = [story1, story2, story3, story4, story5, story6, story7, story8]
// const data = [story1, story2, story3, story4]
export default {
    data
}